import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, light = false }) => (
  <div className="flex items-center gap-3">
    <Leaf className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
    <span
      className={`text-[11px] font-semibold uppercase tracking-[0.28em] ${
        light ? "text-cream/80" : "text-sage"
      }`}
    >
      {children}
    </span>
  </div>
);
